/* FSK secondary-benefit icon popovers -- hover + focus reveal layered on top of the
   native `popovertarget` click/tap behavior already wired in the Liquid markup
   (sections/fsk-benefit-cards.liquid, fsk-also-try.liquid, fsk-shop-by-goal.liquid).
   CSS anchor positioning (anchor-name / position-anchor) is set inline per-instance
   in Liquid, so this file only manages open/close timing -- the same lighter
   mechanism cart-disclosure-tooltip.liquid's anchored-popover-component uses
   (data-hover-triggered), without that custom element, mirroring the approved
   benefit-icon-system mock's own inline script 1:1.

   External file (not inline) so a storefront CSP that forbids inline scripts can't
   silently kill it, and `defer` guarantees it runs after the buttons exist. Guarded
   against double-init since more than one of the three sections above can load this
   file on the same page. */
(function () {
  try {
    if (window.__fskBiconPopoverInit) return;
    window.__fskBiconPopoverInit = true;

    /* Popover API support gate (red-team finding, 2026-07-27). `:popover-open` is an
       INVALID selector in browsers without Popover API support, so the
       `pop.matches(':popover-open')` calls in show()/scheduleHide() below throw
       SyntaxError -- and those calls sit OUTSIDE their own try/catch, while the IIFE's
       outer try only covers setup, never the later event-handler invocations. Result was
       a handler that died on first hover/focus. Bail before wiring anything: the
       `@supports not selector(:popover-open)` block in fsk-design.css hides .fsk-pop in
       these browsers, so there is nothing to open and no listener worth attaching. */
    if (!('showPopover' in HTMLElement.prototype)) return;

    var HIDE_DELAY = 150;

    /* H-13 (2026-07-29, Andrew): the origin pill ("Grown on our farm" / "Wild-foraged" /
       "Wildcrafted") now carries its own hover description, so it joins this mechanism
       instead of getting a second one. It is a <button class="fsk-opill"> rather than a
       .fsk-bicon because it keeps the pill's own styling, hence the extra selector. The
       [popovertarget] guard means pills without a tooltip stay untouched. Everything below
       is inherited as-is, including the touch fix that stops a tap from following the
       card's link before the tooltip can be read. */
    document.querySelectorAll('.fsk-bicon, button.fsk-opill[popovertarget]').forEach(function (btn) {
      var popId = btn.getAttribute('popovertarget');
      var pop = popId ? document.getElementById(popId) : null;
      if (!pop) return;

      var hideTimer;
      function show() {
        clearTimeout(hideTimer);
        if (!pop.matches(':popover-open')) {
          try { pop.showPopover(); } catch (e) {}
        }
      }
      function scheduleHide() {
        hideTimer = setTimeout(function () {
          if (pop.matches(':popover-open')) {
            try { pop.hidePopover(); } catch (e) {}
          }
        }, HIDE_DELAY);
      }

      /* Touch fix (2026-07-21 audit, P2): these buttons sit INSIDE the card's <a>, so a
         tap fired the native popovertarget AND let the click bubble to the anchor --
         the tooltip opened and the device navigated away from it in the same gesture.
         All secondary-benefit tooltips were unusable on touch (~53% of traffic).
         Cancel the anchor navigation and drive the popover manually. Fixed here rather
         than per-section so fsk-benefit-cards / fsk-also-try / fsk-shop-by-goal all
         inherit it (system-level fix, per PF-28). Hover/focus paths below are untouched. */
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        clearTimeout(hideTimer);
        try { pop.togglePopover(); } catch (e2) {}
      });

      btn.addEventListener('mouseenter', show);
      btn.addEventListener('mouseleave', scheduleHide);
      btn.addEventListener('focus', show);
      btn.addEventListener('blur', scheduleHide);
      pop.addEventListener('mouseenter', function () { clearTimeout(hideTimer); });
      pop.addEventListener('mouseleave', scheduleHide);
    });
  } catch (e) {}
})();
